import { Select, Option } from 'element-ui'
import ResourceSvc from '@/services/resource.svc.js';
import store from '@/services/store.js';

const svc = new ResourceSvc();

export default {
    name: 'CourseTypeSelect',
    components: {
        [Select.name]: Select,
        [Option.name]: Option
    },
    data() {
        return {
            selects: {
                simple: '',
                types: []
            },
        }
    },
    methods: {
        changeType(val) {
            store.commit('setUserCourseType', val);
        },
        reload() {
            var that = this;
            svc.userAPI.getCourseTypes().then(response => {
                that.selects.types = response.body;
                that.selects.types = that.selects.types.filter(function (type) {
                    return type.id != 0 && type.isActive == true;
                });
                if (that.selects.types.length == 0) {
                    that.selects.types = [{ id: 0, name: 'There is no available type', isActive: true }];
                }
                else {
                    that.selects.types.unshift({ id: 0, isActive: true, isActiveString: "Yes", name: "All Types" });
                }
                if (that.selects.types.length) {
                    that.selects.simple = response.body[0].id;
                    store.commit('setUserCourseType', response.body[0].id);
                    store.commit('setCourseTypes', JSON.parse(JSON.stringify(response.body)));
                }
            }, response => {
                //todo add interseptor
            });
        }
    },
    created() {
        this.reload();
    }
}



// WEBPACK FOOTER //
// ./src/components/user/courses/courses-tabs/course-type-select/course-type-select.js